import React, { useEffect, useRef } from 'react';
import { BrowserMultiFormatReader } from '@zxing/browser';
import PropTypes from 'prop-types';
function BarcodeScanner({ onScan, onClose }) {
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const readerRef = useRef(new BrowserMultiFormatReader());
  const isScanningRef = useRef(true);

  const startScanning = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: 'environment',
          width: { ideal: 320 },
          height: { ideal: 240 }
        }
      });
      streamRef.current = stream;

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.play();

        readerRef.current.decodeFromVideoElement(
          videoRef.current,
          (result, err) => {
            if (!isScanningRef.current) return;

            if (result) {
              isScanningRef.current = false;
              onScan(result.text);
              stopScanning();
              onClose();
            }
            if (err && err.name !== 'NotFoundException') {
              console.error('Errr:', err);
            }
          }
        );
      }
    } catch (err) {
      console.error('Lỗi webcam:', err);
    }
  };

  const stopScanning = () => {
    isScanningRef.current = false; 

    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop()); 
      streamRef.current = null;
    }

  };

  useEffect(() => {
    startScanning();
    return () => stopScanning();
  }, [onScan, onClose]);

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h2>Scan Barcode</h2>
      <video ref={videoRef} style={{ width: '100%', maxWidth: '500px' }} />
    </div>
  );
}

BarcodeScanner.propTypes = {
  onScan:  PropTypes.func,
  onClose: PropTypes.func
};

export default BarcodeScanner;
